module.exports = __webpack_public_path__ + "img/shopping1.5573d0de.png";